import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Spinner } from "@fluentui/react-components";
import { uploadMedia } from "../../Services/HeedifyServices";
import { useTranslation } from "react-i18next";
import { useMsal } from "@azure/msal-react";
import { Add20Filled, Dismiss20Regular, Save20Regular } from "@fluentui/react-icons";
import "../CSS/AddMediaComponent.css"
import { getAccessToken } from "../../Services/GraphServices";
import { useNotification } from "../GenericComponent/NotificationSystem";
export default function AddMediaComponent(props) {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const { showSuccess, showError } = useNotification();

 const authContext = useMsal();
  let accounts = authContext.accounts;
  let instance = authContext.instance;
  const activeAccount = accounts[0];
  let userId = null;
  let tenantId = null;
  if (accounts[0]) {
    userId = accounts[0].localAccountId;
    tenantId = accounts[0].tenantId;
  }
  const [isSaveLoading, setIsSaveLoading] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const changeHandler = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file || null);
    setIsSelected(!!file);
  };

  const handleSubmission = () => {
    if (!selectedFile) return;

    setIsSaveLoading(true);
   getAccessToken(instance, activeAccount)
      .then((token) => {
        return uploadMedia(props.ACTIVE_TENANT, userId, selectedFile ,token);
      })
      .then((result) => {
        if (result?.success === true) {
          showSuccess(t("MEDIA_UPLOADED_SUCCESS"));
          navigate("/medias");
        } else {
          const errorMsg = result?.message || "Érreur inconnue";
          console.error("Upload échoué:", result);
          showError(t("MEDIA_UPLOAD_ERROR"), errorMsg);
        }
      })
      .catch((error) => {
        console.error("Erreur upload:", error);
        showError(t("MEDIA_UPLOAD_ERROR"));
      })
      .finally(() => {
        setIsSaveLoading(false);
      });
  };

  return (
    <div
    className="media-add-container"
     
    >
      {/* Bouton Ajouter en haut à droite */}
      <div
       className="media-add-wrapper"
      >
        <h4 className="media-add-title">{t("ADD_MEDIA")}</h4>

        <div style={{ display: 'flex', gap: '10px' }}>
          <Button
            icon={<Dismiss20Regular />}
            appearance="secondary"
            onClick={() => navigate("/medias")}
          >
            {t("CANCEL")}
          </Button>
          <Button
            appearance="primary"
            disabled={!selectedFile || isSaveLoading}
            onClick={handleSubmission}
          >
            {isSaveLoading ? (
              <Spinner size="tiny" />
            ) : (
              <>
                <Save20Regular /> {t("SAVE")}
              </>
            )}
          </Button>
        </div>
      </div>

      {/* Zone d'informations */}
      <div className="media-add-form-content">
      <div>
        {isSelected ? (
          <div
           className="media-add-info"
          >
            <p>
              <strong>{t("FILE_NAME")}:</strong> {selectedFile?.name}
            </p>
            <p>
              <strong>{t("FILE_TYPE")}:</strong> {selectedFile?.type}
            </p>
            <p>
              <strong>{t("FILE_SIZE_BYTES")}:</strong> {selectedFile?.size}
            </p>
            <p>
              <strong>{t("LAST_MODIFIED")}:</strong>{" "}
              {selectedFile?.lastModifiedDate
                ? selectedFile.lastModifiedDate.toLocaleDateString()
                : "N/A"}
            </p>
          </div>
        ) : (
          <div
          className="media-add-notice"
          >
            <p>{t("AUDIO_FILE_SHOULD_BE_WAV")}</p>
            <p>{t("AUDIO_FILE_FORMAT_REQUIREMENTS")}</p>
          </div>
        )}
      </div>

      {/* Input stylisé */}
      <div className="media-add-input-wrapper">
        <input
          type="file"
          accept=".wav"
          onChange={changeHandler}
         className="media-add-input"
          onMouseOver={(e) => {
            e.target.style.borderColor = "#005a9e";
            e.target.style.backgroundColor = "#eef6fb";
          }}
          onMouseOut={(e) => {
            e.target.style.borderColor = "#0078d4";
            e.target.style.backgroundColor = "#f8f9fa";
          }}
        />
      </div>
      </div>
    </div>
  );
}
